import { AfterViewInit, Directive, ElementRef, HostListener, inject, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: 'textarea[appAutoResize]',
    standalone: true,
})
export class AutoResizeTextareaDirective implements AfterViewInit, OnDestroy {
    private readonly el = inject(ElementRef<HTMLTextAreaElement>);
    private readonly control = inject(NgControl, { optional: true });
    private subscription?: Subscription;

    @HostListener('input')
    onInput() {
        this.resize();
    }

    ngAfterViewInit() {
        this.resize();

        if (this.control?.valueChanges) {
            this.subscription = this.control.valueChanges.subscribe(() => {
                requestAnimationFrame(() => this.resize());
            });
        }
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    private resize() {
        const textarea = this.el.nativeElement;
        const scrollableParent = this.findScrollableParent(textarea);
        const savedScrollTop = scrollableParent?.scrollTop ?? 0;

        textarea.style.overflow = 'hidden';
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';

        if (scrollableParent) {
            scrollableParent.scrollTop = savedScrollTop;
        }
    }

    private findScrollableParent(el: HTMLElement): HTMLElement | null {
        let parent = el.parentElement;
        while (parent) {
            const { overflowY } = getComputedStyle(parent);
            if (overflowY === 'auto' || overflowY === 'scroll') {
                return parent;
            }
            parent = parent.parentElement;
        }
        return null;
    }
}
